import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslatePipe } from './translate.pipe';

@NgModule({
  imports: [CommonModule],
  providers: [],
  declarations: [TranslatePipe],
  exports: [TranslatePipe],
})
export class TranslationModule {}
